import React from 'react'

function CloseDropDown({setClose}) {
    return (
        <div className="close-dropdown-helper" onClick={() => setClose(false)}></div>
    )
}

export default CloseDropDown